// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9d27e307","243":"d766f5c3","285":"da646fa4","415":"28442482","601":"fd7313de","778":"e64174fa","846":"0c6d3b6e","944":"8774c836"}[chunkId] + ".chunk.js";
};